import { Accordion, AccordionSummary, CardHeader } from '@material-ui/core'
import { ExpandMore, Help } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { ReactSortable } from "react-sortablejs"
import _ from "underscore"
import { ChatControl } from './ChatControl.js'
import { EmailControl } from './EmailControl.js'
import { FileControl } from './FileControl.js'
import { MeetingControl } from './MeetingControl.js'
import { PaymentControl } from './PaymentControl.js'
import { ProductControl } from './ProductControl.js'
import { QRControl } from './QRControl.js'
import { RatingControl } from './RatingControl.js'
import { ShareControl } from './ShareControl.js'
import { UrlControl } from './UrlControl.js'
import { SurveyControl } from './SurveyControl.js'
import { TimerControl } from './TimerControl.js'
import { FormControls } from './FormControl.js'

export const EditControls = ({ onUpdate, controls, selectedControl, onDelete }) => {
    const [selectedControls, setSelectedControls] = useState([]);

    const createCtrl = (name) => {
        const isExist = _.find(controls, l => l.name === name) || selectedControl.name === name;
        const value = _.find(controls, l => l.name === name) ?
            _.find(controls, l => l.name === name).value : selectedControl.value;

        function getUpdatedValue(val) {
            let updatedControls = selectedControls;
            const isControlExist = _.find(controls, l => l.name === name)
            if (isControlExist) {
                updatedControls = selectedControls.map((x) => {
                    if (x.name === name) {
                        x.value = val;
                    }
                    return x;
                })
            }
            else {
                updatedControls = selectedControls;
            }

            return updatedControls;
        }

        if (isExist) {
            switch (name) {
                case "Branding":
                    return <></>
                case "File":
                    return <FileControl
                        isSelected={selectedControl.name === "File"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "File"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "File"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Timer":
                    return <TimerControl
                        isSelected={selectedControl.name === "Timer"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Timer"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Timer"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Email":
                    return <EmailControl
                        isSelected={selectedControl.name === "Email"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Email"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Email"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Calendar":
                    return <MeetingControl
                        isSelected={selectedControl.name === "Calendar"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Calendar"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Calendar"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Payment":
                    return <PaymentControl
                        isSelected={selectedControl.name === "Payment"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Payment"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Payment"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Url":
                    return <UrlControl
                        isSelected={selectedControl.name === "Url"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Url"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Url"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Form":
                    return <FormControls
                        isSelected={selectedControl.name === "Form"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Form"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Form"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Sharing":
                    return <ShareControl
                        isSelected={selectedControl.name === "Sharing"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Sharing"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Sharing"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Chat":
                    return <ChatControl
                        isSelected={selectedControl.name === "Chat"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Chat"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Chat"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Rating":
                    return <RatingControl
                        isSelected={selectedControl.name === "Rating"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Rating"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Rating"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "QR":
                    return <QRControl
                        isSelected={selectedControl.name === "QR"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "QR"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "QR"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Product":
                    return <ProductControl
                        isSelected={selectedControl.name === "Product"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Product"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Product"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                case "Polling":
                    return <SurveyControl
                        isSelected={selectedControl.name === "Polling"}
                        onDelete={() => {
                            onUpdate(selectedControls.filter((x) => x.name !== "Polling"));
                            setSelectedControls(selectedControls.filter((x) => x.name !== "Polling"));
                            onDelete();
                        }}
                        value={value}
                        onUpdate={(val) => onUpdate(getUpdatedValue(val))}
                    />
                default:
                    <div className='w-full'>
                        <Accordion variant='outlined'>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-label="Expand"
                                aria-controls="additional-actions1-content"
                                id="additional-actions1-header"
                            >
                                <CardHeader avatar={<Help color="primary" />} title="New Control" subheader="Not Supported" />
                            </AccordionSummary>
                        </Accordion>
                    </div>
            }
        }
        return <div className='w-full my-2'>
            <Accordion variant='outlined'>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                >
                    <CardHeader avatar={<Help color="primary" />} title={name} subheader="Not Supported" />
                </AccordionSummary>
            </Accordion>
        </div>
    }

    useEffect(() => {
        if (controls.length > 0 || selectedControl.name) {
            let selectedControls1 = controls;
            if (selectedControl.name) {
                selectedControls1 = [...selectedControls1, selectedControl];
                selectedControls1 = _.uniq(selectedControls1, x => x.name);
            }
            setSelectedControls(selectedControls1)
        }
        else {
            setSelectedControls([]);
        }
    }, [controls, selectedControl]);

    return (
        <div>
            {
                selectedControls.length > 0 ? <ReactSortable
                    handle='.handle'
                    list={selectedControls} setList={(newState, sortable, str) => {
                        setSelectedControls(newState);
                        onUpdate(newState);
                    }}>
                    {
                        selectedControls.map((item) => (
                            <div key={item.name} className="my-2">
                                {createCtrl(item.name.toString())}
                            </div>
                        ))
                    }
                </ReactSortable> :
                    <></>
            }
        </div >
    )
}
